/**
 * Payload za POST /cso/register i POST /public-body/register.
 * BE: OrganizationRegistrationReq (first_name, last_name, phone, email).
 */

import { normalizeOrganizationAdditionalInfo } from '@/shared/services/OrganizationService';

/**
 * @param {object} data
 * @returns {{ name: string, first_name?: string, last_name?: string, phone?: string, email?: string }}
 */
export function buildOrganizationRegistrationApiBody(data) {
  if (!data?.name?.trim()) {
    throw new Error('Naziv organizacije je obavezan');
  }

  const contact = normalizeOrganizationAdditionalInfo(data);
  const body = { name: data.name.trim() };

  if (contact.first_name) body.first_name = contact.first_name;
  if (contact.last_name) body.last_name = contact.last_name;
  if (contact.phone) body.phone = contact.phone;
  if (contact.email) body.email = contact.email;

  return body;
}
